import './information.css';
function Information (props){
    return (
        <div className="div">
            <p className='titel'>{props.titel}</p>
            <p className='tite2'>{props.information}</p>
        </div>
    )
}
export default Information